import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetAllBlogs } from '../../Redux/Auth/Auth_Action';

const Blogs = () => {

    const dispatch = useDispatch();
    const [state, setState] = useState({ stateData: [] });

    const getBlogs = () => {
        dispatch(GetAllBlogs())
            .then((res) => {
                // console.log("working podcast", res.data);
                setState({ ...state, stateData: res.data.response.data.data });
            }).catch((e) => {
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        getBlogs();
    }, [])

    return (
        <div>
            <div className='row'>
                <div className="col-lg-12 text-center mt-5 mb-5">
                    <p className="f-30 f-mon-reg text-white mb-0">
                        BLOGS & NEWS
                    </p>
                    <p className='f-16 txt-captl f-mon-bold text-white lh-01 mt-1'>Here you can find out the latest news on all online game prediction and other sports</p>
                    <p className="f-32 txt-captl f-mon-bold text-white lh-01 mt-1">
                        Get every sport bet challenger news and updates here.
                    </p>
                    <div className="border-btm-pink-secondsec my-3">
                    </div>
                </div>
                {state?.stateData?.slice(0, 3)?.map((item, index) => {
                    return (
                        <div key={index} className='col-lg-4 mb-5'>
                            <Link to={`/blogdetails/${item.id}`}>
                                <div className='card_blogs'>
                                    {(item?.media_url?.slice(-3) === "mp4")
                                        ?
                                        <video width="100%" height="300" controls controlsList="nodownload" >
                                            <source src={`${item.media_url}`} type="video/mp4" />
                                        </video>
                                        :
                                        <img src={item.media_url} className="blog_img" alt="blogs" />
                                    }
                                    {/* <img src={item.media_url} className="blog_img" alt="blogs" /> */}
                                    <p className='f-mon-reg f-24 text-white hdd-limt1'>{item.title}</p>
                                    {/* <div className='f-mon-reg f-16 text-white f-hiid wht-dangerously-txt' dangerouslySetInnerHTML={{ __html: item.description }}></div> */}
                                </div>
                            </Link>
                        </div>
                    );
                })};
                <div className='col-lg-12 text-center mb-5'>
                    <Link to='/blogs' className='f-mon-light f-18 text-white read_more'>
                        <button className="btn btn-light f-16 f-mon-reg btn-pink-now mb-5 mt-1 pad-btn-ho-fifth" >
                            VIEW MORE
                        </button>
                    </Link>
                    {/* Read More */}
                </div>
            </div>
        </div>
    )
}

export default Blogs;